// Version: 2.2
// v2.2: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';

export default function Register() {
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('');
  const [company,  setCompany]  = useState('');
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [done,     setDone]     = useState(false);
  const [policy,   setPolicy]   = useState(null);
  const [productName, setProductName] = useState('');
  const [tagline,  setTagline]  = useState('Cyber Security · STG Limited');

  useEffect(() => {
    fetch('/api/config/password-policy')
      .then(r => r.json())
      .then(d => setPolicy(d))
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetch('/api/health')
      .then(r => r.json())
      .then(d => {
        if (d.product) setProductName(d.product);
        if (d.tagline) setTagline(d.tagline);
      })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase(), company: company.trim(), password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Registration failed');
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="login-logo-stg">STG</span>
            <span className="login-logo-sep" />
            <span className="login-logo-sub">{productName || 'Portal'}</span>
          </div>
          <div className="login-tagline">{tagline}</div>
        </div>
        <div className="login-body">
          {done ? (
            <div style={{textAlign:'center',padding:'12px 0'}}>
              <div style={{fontSize:36,marginBottom:12}}>✓</div>
              <div style={{fontWeight:700,fontSize:16,color:'var(--text)',marginBottom:8}}>Registration received</div>
              <div style={{fontSize:13,color:'var(--text-muted)',marginBottom:20,lineHeight:1.6}}>
                Your account is pending authorisation by the STG team. You'll receive an email once approved.
              </div>
              <Link className="btn btn-primary" to="/login">Back to sign in</Link>
            </div>
          ) : (
            <>
              <p style={{fontSize:13,color:'var(--text-muted)',marginBottom:16}}>
                Register for access to {productName ? `the ${productName} portal` : 'this portal'}. Your account will be reviewed and activated by the STG team.
              </p>
              {policy && (
                <div style={{background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:'var(--radius)',padding:'10px 14px',marginBottom:16,fontSize:12,color:'var(--text-muted)'}}>
                  <div style={{fontWeight:600,marginBottom:4,color:'var(--text)'}}>Password requirements</div>
                  <div>• At least {policy.min_length} characters</div>
                  {policy.block_common && <div>• Must not be a commonly used password</div>}
                  {policy.require_complexity && <div>• Must include uppercase, number and symbol</div>}
                </div>
              )}
              <form onSubmit={handleSubmit} className="login-form">
                <div className="login-field">
                  <label>Email Address</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="your@company.com" required autoFocus />
                </div>
                <div className="login-field">
                  <label>Company Name</label>
                  <input type="text" value={company} onChange={e => setCompany(e.target.value)}
                    placeholder="Acme Corporation" required />
                </div>
                <div className="login-field">
                  <label>Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                    placeholder={`Min ${policy?.min_length || 12} characters`} required />
                </div>
                <div className="login-field">
                  <label>Confirm Password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                    placeholder="Repeat password" required />
                </div>
                {error && <div className="error-msg">{error}</div>}
                <button className="btn btn-primary btn-lg login-btn" type="submit" disabled={loading}>
                  {loading ? <span className="spinner" /> : 'Request Access'}
                </button>
                <div style={{textAlign:'center',fontSize:13}}>
                  <Link to="/login" style={{color:'var(--text-muted)'}}>← Back to sign in</Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
